import { dataHooks } from '@wix/data-hooks';

export const dispatchInfoDataHooks = dataHooks<{
  root: {};
  timeRow: {};
  timeLabel: {};
  timeChangeButton: {};
  addressRow: {};
  addressLabel: {};
  addressChangeButton: {};
}>('dispatch-info');
